import { categorySchema, type Category } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const postRestore = (id: string): Promise<unknown> =>
  apiRequest<unknown>(`/categories/${id}/restore`, { method: 'POST' });

export const restoreCategory = async (id: string): Promise<Category> =>
  categorySchema.parse(await postRestore(id));
